import { Icon20Stars } from '@vkontakte/icons';
import { Title } from '@vkontakte/vkui';
import React, { type FC, memo, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { renderFullScreenAiPhotoGeneration } from 'reactApp/ui/AiPhotoGeneration/Modals/MainScreen/FullScreenAiPhotoGenerationModal.helpers';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './AiPhotoGenerationEntryButton.css';

interface IProps {
    className?: string;
}

const AiPhotoGenerationEntryButton: FC<IProps> = memo(function AiPhotoGenerationEntryButton(props) {
    const { className } = props;
    const storage = useSelector(getCurrentStorage);

    const handleClick = useCallback(() => {
        sendPaymentGa({
            eventCategory: ECategoryGa.aiPhotoGeneration,
            action: 'entry-button-click',
            source: storage,
            dwh_enabled: true,
            dwh_enabled_fields: [['paid_user', 'corp_user', 'source']],
        });

        renderFullScreenAiPhotoGeneration();
    }, [storage]);

    useEffect(() => {
        sendPaymentGa({
            eventCategory: ECategoryGa.aiPhotoGeneration,
            action: 'entry-button-show',
            source: storage,
            dwh_enabled: true,
            dwh_enabled_fields: [['paid_user', 'corp_user', 'source']],
        });
    }, [storage]);

    return (
        <div className={className}>
            <div className={styles.button} onClick={handleClick}>
                <Icon20Stars width={20} height={20} color="var(--vkui--color_text_contrast)" />
                <Title level="3" className={styles.text}>
                    Сгенерировать изображение
                </Title>
            </div>
        </div>
    );
});

AiPhotoGenerationEntryButton.displayName = 'AiPhotoGenerationEntryButton';

export default AiPhotoGenerationEntryButton;
